import axios from 'axios'  //引用安装好的axios


import {
	getAesKey,
	aesDecrypt,
	aesEncrypt,
	DecryptNode,
	EncryptNode
} from './secret.js'

const baseURL = 'charge'

const service = axios.create({
    baseURL: baseURL, // url = base url + request url
    withCredentials: true, // send cookies when cross-domain requests
    // timeout: 5000, // request timeout
    crossDomain: true
})
//params 用于get请求 拼接在url后面
//data 用于post请求放在请求体里面
export default function ajax(url = '', params = {}, medthod = {}) {
    // 1. 定义promise对象
    let promise;
    return new Promise((resolve, reject) => {
		
		
		var dataStr = JSON.stringify(params)
		var key = getAesKey(16);
		var enParm = aesEncrypt(dataStr, key)
		var encodStr = EncryptNode(key)
		 params = {
			data: enParm,
			secretKey: encodStr
		}
		
        
		
		// 判断请求类型
		let headerData = {
			// 'content-type': 'application/x-www-form-urlencoded'	
		}
		if (localStorage.getItem('token')) {
			headerData.token = localStorage.getItem('token')
		}
		let config = {
			headers:headerData
		}
		if(medthod =='post'){
			promise = service.post(url, params,config)
		}if(medthod =='get'){
			/* 拼在URL后面的参数 */
			let paramsStr = '';
			      //如果所有接口有一个统一的必传的值可在这设置
			/*  paramsStr += 'version' + '=' + "1.4" + '&'; //版本
			    paramsStr += 'app' + '=' + "1" + '&'; //app */
			Object.keys(params).forEach(key => {
			    paramsStr += key + '=' + params[key] + '&'
			});
			if (paramsStr !== '') {
			    paramsStr = paramsStr.substr(0, paramsStr.lastIndexOf('&'))
			}
			
			url += '?' + paramsStr;
			promise = service.get(url,config)
		}
        
        // 3. 返回请求的结果
        promise.then((response) => {
			
			// var responValue = response.data
			
			var responKey = DecryptNode(response.data.secretKey)
			var data = response.data.data.replace(/[\r\n]/g, "")
			var responValue = aesDecrypt(data, responKey)
			console.log(responValue)
			
            resolve(responValue)
        }).catch(error => {
            reject(error)
        })
    })
}